import React, { useState, useRef } from 'react';
import { Segment } from 'tea-component';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import ArrowdownText from '@/pages/intelligence/components/ArrowdownText';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import useDemographicsBarCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useDemographicsBarCharts';
import { useIntl } from 'umi';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { DATA_SOURCE_NAME_MAP } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';

export const SEGMENT_KEYS = ['gender', 'age'];

const Demographics = (props: any) => {
  const {
    barOrPieData,
    cardStatus,
    dateType,
    sortKeyName,
    orderKey,
    segVal,
    setSegVal,
    source,
  } = props;
  const { formatMessage, locale } = useIntl(); // 中英切换方法
  const [chartType, setChartType] = useState('bar');
  const cardRef = useRef<HTMLDivElement>(null);
  const { isLoading, isError, isNoData } = cardStatus || {};

  const orderSourceNameRaw = DATA_SOURCE_NAME_MAP?.[source] || source || '';
  const orderSourceName = typeof orderSourceNameRaw === 'string' ? orderSourceNameRaw.trim() : `${orderSourceNameRaw}`.trim();
  // sortKeyName 可能来自 SortBy 的 title，部分场景会带前导/尾部空格，这里统一 trim 掉
  const metricName = typeof sortKeyName === 'string' ? sortKeyName.trim() : `${sortKeyName || ''}`.trim();

  const isZh = typeof locale === 'string' && locale.toLowerCase().startsWith('zh');
  // 中文："Sensor Tower月活"；英文："Sensor Tower MAU"
  const sortedDataText = isZh
    ? `${orderSourceName}${metricName}`.trim()
    : `${orderSourceName}${metricName ? ` ${metricName}` : ''}`.trim();

  const segmentTextMap: IRecord<string> = {
    gender: formatMessage({ id: `dbi_top_gender_breakdown` }),
    age: formatMessage({ id: `dbi_top_age_breakdown` }),
  };

  const segments = SEGMENT_KEYS.map((value) => {
    return {
      value,
      text: segmentTextMap[value] || value || '',
    };
  });

  const { options } = useDemographicsBarCharts({
    barOrPieData,
    loading: isLoading,
    segVal: segVal,
    cardWidth: cardRef?.current?.clientWidth || 0,
    dateType,
  });

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: `dbi_top_demographics_breakdown` })}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} height={394} />
      </CardSlotV2>
    );
  }

  return (
    <>
      <CardSlotV2
        title={
          <div style={{ display: 'flex'}}>
            <span style={{ marginRight: 10 }}>{ formatMessage({ id: `dbi_top_demographics_breakdown` })}</span>
            <ArrowdownText
              isNew={true}
              sortedData={sortedDataText}
              order={orderKey}
            />
          </div>
        }
        activeTab={chartType}
        className="dbi-detail-card"
        disableChartType={['line', 'pie']}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <div className="dbi-card-segment demograp-card-flex">
          <Segment
            className="segment-box"
            value={segVal}
            onChange={(value) => setSegVal(value)}
            options={segments}
          />
          {/* <ArrowdownText
            isNew={true}
            sortedData={'data.ai ' + sortKeyName}
            order={orderKey}
          /> */}
        </div>
        <div className="dbi-char-data" ref={cardRef}>
          <ChartsIndex
            chartType={chartType}
            chartLoading={false}
            // lineOption={lineOption}
            // isNodata={isNodata}
            // pieOption={pieOption}
            barOption={options}
          />
        </div>
      </CardSlotV2>
    </>
  );
};

export default Demographics;
